import { SAP_ENGINE } from "./sql-connection-engines";
import { createSqlConnectionForm } from "./sql-connection-form";

/** SAP RFC. Everything but the engine spec lives in `sql-connection-form.tsx`. */
const createConnectionSAP = createSqlConnectionForm(SAP_ENGINE);
export { createConnectionSAP as CreateConnectionSAP };
